import {
  Badge,
  makeStyles,
  Theme,
  Tooltip,
  Typography,
} from '@material-ui/core'
import CircularProgressBarWithText from 'components/Layout/CircularProgressBarWithText'
import { useAppSelector } from 'store/configureStore'
import { NotificationType } from 'services/APIs/InternalAPI/internal-api.contracts'
import { bomItemIssuesCounterSelector } from '../store/selectors/bomItemIssuesSelector'
import { bomItemRowNumberSelector } from '../store/selectors/bomItemNumberSelector'
import { BomItemIssues } from './BomItemIssues'

const useStyles = makeStyles((theme: Theme) => ({
  circularProgressFix: {
    display: 'flex',
    minWidth: `${theme.spacing(5)}px`,
    minHeight: `${theme.spacing(5)}px`,
  },
}))

export const PartTypeRowNumber = ({ bomItemId }: { bomItemId: string }) => {
  const classes = useStyles()

  const bomItemRowNumber = useAppSelector(bomItemRowNumberSelector(bomItemId))
  const issuesCount = useAppSelector(bomItemIssuesCounterSelector(bomItemId))

  if (!issuesCount) {
    return (
      <Typography variant="caption" color="textSecondary">
        {bomItemRowNumber}
      </Typography>
    )
  }

  return (
    <Tooltip
      title={issuesCount === 0 ? '' : <BomItemIssues bomItemId={bomItemId} />}
      placement="left"
      arrow
    >
      <Badge
        badgeContent={issuesCount}
        color="error"
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        overlap="circular"
      >
        <CircularProgressBarWithText
          notificationType={
            issuesCount > 0 ? NotificationType.Danger : NotificationType.Info
          }
          text={bomItemRowNumber}
          progress={issuesCount > 0 ? 100 : 0}
          rootClassName={classes.circularProgressFix}
        />
      </Badge>
    </Tooltip>
  )
}
